/**
 * Validation utilities
 */
/**
 * Validate priority is within range 1-5
 */
export function validatePriority(priority) {
    return Number.isInteger(priority) && priority >= 1 && priority <= 5;
}
/**
 * Validate difficulty is within range 1-5
 */
export function validateDifficulty(difficulty) {
    return Number.isInteger(difficulty) && difficulty >= 1 && difficulty <= 5;
}
/**
 * Validate estimated minutes is positive
 */
export function validateEstimatedMinutes(minutes) {
    return Number.isInteger(minutes) && minutes > 0;
}
/**
 * Validate HH:MM time format
 */
export function validateTimeFormat(time) {
    const regex = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
    return regex.test(time);
}
/**
 * Validate ISO date string format (YYYY-MM-DD)
 */
export function validateISODateFormat(date) {
    const regex = /^\d{4}-\d{2}-\d{2}$/;
    if (!regex.test(date))
        return false;
    const d = new Date(date);
    return !isNaN(d.getTime());
}
/**
 * Validate ISO datetime string format
 */
export function validateISODateTimeFormat(datetime) {
    const d = new Date(datetime);
    return !isNaN(d.getTime());
}
/**
 * Validate energy level
 */
export function validateEnergyLevel(level) {
    return ['low', 'medium', 'high'].includes(level);
}
/**
 * Validate task status
 */
export function validateTaskStatus(status) {
    return ['todo', 'in_progress', 'completed', 'blocked'].includes(status);
}
/**
 * Validate project status
 */
export function validateProjectStatus(status) {
    return ['active', 'paused', 'completed', 'archived'].includes(status);
}
/**
 * Validate goal status
 */
export function validateGoalStatus(status) {
    return ['active', 'achieved', 'abandoned'].includes(status);
}
/**
 * Validate recurrence frequency
 */
export function validateRecurrenceFrequency(frequency) {
    return ['daily', 'weekly', 'monthly'].includes(frequency);
}
/**
 * Validate list type
 */
export function validateListType(type) {
    return ['eternal', 'template', 'quick'].includes(type);
}
/**
 * Clamp a value between min and max
 */
export function clamp(value, min, max) {
    return Math.max(min, Math.min(max, value));
}
/**
 * Sanitize string for use in file names
 */
export function sanitizeFileName(name) {
    return name
        .replace(/[/\\:*?"<>|]/g, '-')
        .replace(/\s+/g, ' ')
        .trim();
}
//# sourceMappingURL=validation.js.map